module.exports = __webpack_public_path__ + "static/img/bot-step-5.d2ddcbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bot-step-5.png
// module id = 8P2N
// module chunks = 11